export const automationDropdownID = 'automation';
export const automationSearchID = 'automation-search';
export const automationOverviewListID = 'automation-rules-list';
export const automationOverviewListItemID = 'automation-rules-list-item';
